import { useCallback } from 'react';
import { useRouter } from 'expo-router';

export const useScanToPayNavigation = (closeModal: () => void) => {
  const router = useRouter();

  const goToSgRewards = useCallback(() => {
    closeModal();

    router.dismissTo('/loyalty');
  }, [closeModal, router]);

  const goToForgotToScan = useCallback(() => {
    closeModal();

    router.navigate('/forgot-to-scan');
  }, [closeModal, router]);

  const goToSupport = useCallback(() => {
    closeModal();

    router.navigate('/chat');
  }, [closeModal, router]);

  const goBack = useCallback(() => {
    closeModal();

    router.back();
  }, [closeModal, router]);

  return {
    goToSgRewards,
    goToForgotToScan,
    goToSupport,
    goBack,
  };
};
